import { createStackNavigator } from '@react-navigation/stack';
import i18n from 'i18n-js';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Agb from '../../screens/Agb';
import Login from '../screens/Login';
import ModalDemo from '../../screens/modals/ModalDemo';
import ModalMessage from '../../screens/modals/ModalMessage';
import ModalResetPW from '../../screens/modals/ModalResetPW';
import QRCodeLogin from '../../screens/QRCodeLogin';
import Header from '../components/basic/Header';
import ModalSimulator from '../components/modals/ModalSimulator';
import SideNavigationBar from "./SideNavigationBar";
import * as Browser from '@sentry/react';

import { backendSync, backendTokenLogin } from "../../stores/thunks";
import { switchScreen } from "../../hooks/navigate";
import { InteractionManager } from "react-native";
import { useNavigation } from "@react-navigation/native";
import 'reactflow/dist/style.css';

// ? worklflow editor
import Editor from "../screens/Editor";
import EditorHeader from "../components/basic/EditorHeader";

// ? detail views
import ContactScreen from "../screens/ContactScreen";
import ContactHeader from "../components/basic/ContactHeader";
import { wsSend } from "../../stores/mainSlice";

const studioStack = createStackNavigator() // +

const headerOptions = {
  headerShown: true,
  header: (props) => <Header {...props} />,
  presentation: 'modal',
  unmountOnBlur: true
}

// export const navigation = useNavigation();

export default function Studio() {
  const settings = useSelector((state) => state.settings)
  const server = useSelector((state) => state.server)
  const user = useSelector((state) => state.user)
  const message = useSelector((state) => state.temp.msg)

  const dispatch = useDispatch()
  const navigation = useNavigation();

  // // ---
  // navigation.addListener('state', () => {
  //   console.log('Studio.js', 'navigation:state', navigation.getState());
  // });
  // // ---

  useEffect(() => {
    console.ina('SIGNEDIN', user)
    if (user.isSignedIn) {
      Browser.setUser({
        id: user.id,
        name: user.preferredName,
        email: user.mail
      })
      if (!user.demo) {
        dispatch(wsSend({ msg: { type: 'USER', receivers: [], data: null } }))
        if (server?.token?.value) { //  && !(server.online && server.login && Date.now() - server.login < 60 * 60000)
          dispatch(backendTokenLogin('ONLINE'))
        }
      }
    }
  }, [user.isSignedIn])

  useEffect(() => {
    if (message) {
      switchScreen(navigation, 'ModalMessage', { message: message })
    }
  }, [message])

  useEffect(() => {
    let syncInterval = null
    if (server.online) {
      console.ina("SYNC BEG", JSON.stringify(server.sync, null, 2))
      // start the regular check for sync to be done
      syncInterval = setInterval(() => {
        InteractionManager.runAfterInteractions(() => {
          // console.ina('RUN Sync')
          dispatch(backendSync())
        });

      }, 10000)
    } else {
      if (syncInterval) {
        console.ina("SYNC END")
        clearInterval(syncInterval)
        syncInterval = null
      }
    }
    return function cleanup() {
      if (syncInterval) {
        console.ina("SYNC FIN")
        clearInterval(syncInterval)
        syncInterval = null
      }
    }
  }, [server.online])

  // // ---
  // console.log('Studio.js', 'nav-path', globalThis.location.pathname)
  // console.log('Studio.js', { settings, tou_or_dpa: settings.showTOU || settings.showDPA })
  // console.log('Studio.js', { isSignedIn: user.isSignedIn })
  // // ---

  return (settings.showTOU || settings.showDPA) ? (
    <studioStack.Navigator initialRouteName='Agb' screenOptions={headerOptions}>
      <studioStack.Screen name='Agb' component={Agb} options={{ title: i18n.t(settings.showTOU ? 'tou.header' : 'dpa.header'), info: i18n.t(settings.showTOU ? 'tou.info' : 'dpa.info'), basic: true }} />
    </studioStack.Navigator>
  ) : (
    user.isSignedIn ? (
      <studioStack.Navigator initialRouteName='Studio' screenOptions={headerOptions}>
        {/* --- */}
        {/* FIXME(@Milo): The `name` attribute on <Screen name="..."> must match the key used in the
          linking config, NOT the URL path.

          The `name` is an internal identifier for navigation and deep linking resolution. To avoid
          confusion, update the names to use a descriptive key and ensure the linking config uses
          the same key. The URL path is defined separately in the linking config.
        */}
        <studioStack.Screen name='Studio' component={SideNavigationBar} />
        <studioStack.Screen name='editor' component={Editor} options={{
          title: i18n.t('studio.editor.title'),
          header: (props) => <EditorHeader {...props} />
        }} />
        <studioStack.Screen name='ViewContact' component={ContactScreen} options={{
          title: i18n.t('studio.contact.title'),
          header: (props) => <ContactHeader {...props} />
        }} />
        <studioStack.Screen name='ViewChannel' component={ContactScreen} options={{
          title: i18n.t('studio.channel.title'),
          header: (props) => <ContactHeader {...props} />
        }} />
        <studioStack.Screen name='ModalMessage' options={{
          title: i18n.t('message.info'),
          basic: true
        }} >{(props) => <ModalMessage  {...props} message={message} />}</studioStack.Screen>
        {/* --- */}
        <studioStack.Screen name='ModalSimulator' component={ModalSimulator} options={{ headerShown: false, presentation: 'transparentModal' }} />
      </studioStack.Navigator>
    ) : (
      <studioStack.Navigator initialRouteName='Login' screenOptions={headerOptions}>
        <studioStack.Screen name='Login' component={Login} options={{ headerShown: false }} />
        <studioStack.Screen name='ModalResetPW' component={ModalResetPW} options={{ headerShown: false, presentation: 'transparentModal' }} />
        <studioStack.Screen name='ModalDemo' component={ModalDemo} options={{ headerShown: false, presentation: 'transparentModal' }} />
        <studioStack.Screen name='QRCodeLogin' component={QRCodeLogin} options={{ title: i18n.t('login.title'), info: i18n.t('login.info'), basic: true }} />
        <studioStack.Screen name='ModalMessage' options={{ title: i18n.t('message.info'), basic: true }}>
          {(props) => <ModalMessage  {...props} message={message} />}
        </studioStack.Screen>
      </studioStack.Navigator>)
  )
}
